import React, { useState } from 'react';
import styled from 'styled-components';
// import startCase from 'lodash-es/startCase';
import {
  Box,
  BInput,
  BTextArea,
  Button,
  Title1,
  Checkbox,
  Body2,
  // OptionButton,
} from 'components/core';
import { FormUpload } from 'components/upload';

import { getIsValid, generateUploadKey } from 'utils/form';
import { getCategoryImageKey } from 'utils/image';

const TextArea = styled(BTextArea)`
  min-height: 108px;
`;

// const OptionRow = styled(Box)`
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
//   align-self: stretch;
// `;

const isValid = getIsValid([]);
// const dayOptions = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
const category = 'supplement';

// const genMap = (arr = []) => {
//   const result = {};
//   arr.forEach((item) => {
//     result[item] = item;
//   });
//   return result;
// };

// const getArr = (obj = {}) => {
//   return Object.keys(obj).filter((key) => !!obj[key]);
// };

function DietForm({
  userId,
  userGender,
  position,
  onSubmit,
  allowRepeat = true,
  value: initialValue = {},
  ...props
}) {
  const [note, setNote] = useState(initialValue.note);
  // const [weekdays, setDays] = useState(genMap(initialValue.weekdays));
  const [other, setOther] = useState(initialValue.other);

  const [assetType, setAssetType] = useState(initialValue.assetType || 'image');
  const [assetUrl, setAssetUrl] = useState(initialValue.assetUrl || '');
  const [thumbUrl, setThumb] = useState(initialValue.thumbUrl || '');
  const [isDisabled, setIsDisabled] = useState(false);
  const [isRepeated, setRepeated] = useState(false);

  const { day } = position || { day: 1 };
  const uploadKey = generateUploadKey(userId, 'master', 0, day);
  const videoCategoryImage = getCategoryImageKey(category, '', userGender);

  const onUpload = ({ assetUrl, type, fileKey }) => {
    setAssetType(type);
    setAssetUrl(assetUrl);
    if (type === 'image') {
      setThumb(`https://bcult.imgix.net/${fileKey}`);
    } else if (type === 'video') {
      setThumb(`https://bcult.imgix.net/${videoCategoryImage}`);
    } else {
      setThumb('https://source.unsplash.com/random/105x155');
    }
    setIsDisabled(false);
  };

  const onReset = () => {
    setAssetType('');
    setAssetUrl('');
    setThumb('');
  };

  const onChangeOther = (e) => {
    const { value } = e.target;

    setOther(value);
  };

  const onChangeNote = (e) => {
    const { value } = e.target;

    setNote(value);
  };

  // const onToggleOption = (option) => {
  //   const { [option]: optionValue, ...restDays } = weekdays;

  //   if (optionValue) {
  //     setDays(restDays);
  //     return;
  //   }

  //   setDays({
  //     ...restDays,
  //     [option]: option,
  //   });
  // };

  const onSubmitForm = () => {
    const submitValue = {
      other,
      note,
      // days: getArr(weekdays),
      assetType,
      assetUrl,
      thumbUrl,
    };
    if (!isValid(submitValue)) {
      return;
    }

    if (onSubmit) {
      onSubmit(submitValue, isRepeated);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection={['column', 'row']}
      alignSelf="stretch"
      alignItems={['center', 'flex-start']}
      justifyContent="flex-start"
      {...props}
    >
      <FormUpload
        category={category}
        thumbUrl={thumbUrl}
        uploadKey={uploadKey}
        assetType={assetType}
        assetUrl={assetUrl}
        onReset={onReset}
        onUpload={onUpload}
        onUploadProgress={(isUploading) => {
          setIsDisabled(isUploading);
        }}
      />
      <Box
        display="flex"
        flexDirection="column"
        alignSelf="stretch"
        alignItems={['center', 'flex-start']}
        justifyContent="flex-start"
        py={[2, 8]}
        pr={[0, 6]}
      >
        <Title1 mb={[4, 8]}>Supplement</Title1>
        <Box
          display="flex"
          flexDirection="row"
          alignSelf="stretch"
          alignItems="center"
          justifyContent="flex-start"
          mb={[2, 4]}
        >
          <BInput
            value={other}
            placeholder="Other..."
            onChange={onChangeOther}
          />
        </Box>
        {/* <OptionRow mb={[2, 4]}>
          {dayOptions.map((name, index) => (
            <OptionButton
              key={name}
              name={name}
              selected={!!weekdays[name]}
              onClick={() => onToggleOption(name, index)}
            >
              {startCase(name)}
            </OptionButton>
          ))}
        </OptionRow> */}
        <TextArea
          placeholder="Note..."
          value={note}
          onChange={onChangeNote}
          mb={[2, 4]}
        />
        {allowRepeat && (
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-start"
            alignSelf={['unset', 'stretch']}
            mb={[2, 6]}
          >
            <Checkbox
              variant="tick"
              size="sm"
              pt={`2px`}
              mr={1}
              checked={isRepeated}
              onChange={() => setRepeated(!isRepeated)}
            />
            <Body2>Repeat</Body2>
          </Box>
        )}

        <Button
          variant="secondary"
          onClick={onSubmitForm}
          disabled={isDisabled}
        >
          OK
        </Button>
      </Box>
    </Box>
  );
}

export default DietForm;
